import { render, staticRenderFns } from "./IngresoCPConceptos.vue?vue&type=template&id=6fa99820&"
import script from "./IngresoCPConceptos.vue?vue&type=script&lang=js&"
export * from "./IngresoCPConceptos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports